{
  "name": "14-(3,5) < 256°",
  "description": "14-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes 3 and 5. Odd harmonics produce distinct pitch classes, and mark their lowest, i.e., most consonant, position from the generating fundamental. JI intervals, chords, gamuts, melodies are all sets of odd partials. By limiting component primes and maximum partial, harmonic radius is minimised, providing greater perceived harmonicity.",
  "scale": [
    "135/128",
    "9/8",
    "75/64",
    "5/4",
    "81/64",
    "45/32",
    "3/2",
    "25/16",
    "27/16",
    "225/128",
    "15/8",
    "243/128",
    "125/64",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "OddPartials(3,5)",
  "built_in_group": "Odd Partial Pitch Class Sets",
  "key_labels": "note_names",
  "note_names": [
    "1",
    "135",
    "9",
    "75",
    "5",
    "81",
    "45",
    "3",
    "25",
    "27",
    "225",
    "15",
    "243",
    "125"
  ],
  "note_colors": [
    "#ffdbdb",
    "#fffae5",
    "#ffffff",
    "#fef5be",
    "#fffae5",
    "#ffffff",
    "#fffae5",
    "#ffffff",
    "#fef5be",
    "#ffffff",
    "#fef5be",
    "#fffae5",
    "#ffffff",
    "#ffef8a"
  ],
  "equivSteps": 14,
  "fundamental": 440,
  "reference_degree": 9,
  "center_degree": 0,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
